<template>
  <SideMenu class="top-0" />

  <div class="mt-30">
    <slot />
  </div>

  <SiteFooter />
</template>
